import { Component, OnInit } from '@angular/core';
import { ValoresEstadoTasacion } from '../../models/TasacionModel';

@Component({
  selector: 'app-cell-image-formatter',
  templateUrl: './cell-image-formatter.component.html',
  styleUrls: ['./cell-image-formatter.component.scss']
})
export class CellImageFormatterComponent implements OnInit {

  public params: any;

  public prueba: any;
  public prueba2: string;

  public valor: boolean;
  public estado: string;

  constructor() { }

  ngOnInit() {
    this.estado = "";
    this.valor = false;
    this.tieneIncidencia();
  }

  agInit(params: any): void {
    this.params = params;
  }

  tieneIncidencia() {
    
    if (this.params.modo != null && this.params.modo === "isActivo") {
      this.valor = this.params.value;
    } else {
      this.prueba2 = this.params.value + '';
      this.prueba = this.prueba2.split(';');

      if (this.prueba[0] === ValoresEstadoTasacion.EnIncidencia.toString()
        || this.prueba[0] === ValoresEstadoTasacion.ReclamacionCliente.toString()
        || this.prueba[0] === ValoresEstadoTasacion.Anulado.toString()) {
        this.valor = true;
      }
      else if (this.prueba[0] == ValoresEstadoTasacion.InformeEntregado) {
        this.valor = false;
      } else {
        this.valor = null;
      }

      this.estado = this.prueba[1];

      //this._IncidenciasService.getTieneIncidencia(this.params.value).subscribe(data => { this.valor = data });
      //this._TasacionService.getEstadoTasacion(this.params.value).subscribe(data => { this.estado = data; });
    }
  }
}
